<template>
  <m-layout grow>
    <menu-item v-for="item in menu" :key="item.id" :item="item">
      <div class="children">
        <menu-item radial v-for="child in item.children" :key="child.id" :item="child">
          <div class="children">
            <menu-item v-for="grandchild in child.children" :key="grandchild.id" :item="grandchild" />
          </div>
        </menu-item>
      </div>
    </menu-item>
  </m-layout>
</template>

<script>
import MenuItem from '@/components/rules/menu/Item'
import MLayout from '@/components/layouts/MLayout'
import { mapState } from 'vuex'

export default {
  components: { MenuItem, MLayout },
  computed: {
    ...mapState({
      menu: state => state.rules.menu
    })
  },
  mounted () {
    this.$store.dispatch('rules/GET_MENU')
  },
  watch: {
    '$i18n.locale' (to, from) {
      this.$store.dispatch('rules/GET_MENU')
    }
  }
}
</script>

<style scoped>
.children { padding-left: 10px; }
</style>



// WEBPACK FOOTER //
// src/components/rules/menu/List.vue